//image sizes for tmdb

export const model = localStorage['model'] || "gtr4";
export const gtechurl = "https://getech2018.github.io/";
export const adsofturl = "https://adsofttech.github.io/";
export const miurl = "https://miwatchfaces.com/";
	

export const qrcodeurl = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=zpkd1://getech2018.github.io/wfzpk/";
export const qrcodeurl2 = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=zpkd1://getech2018.github.io/wfzpk2/";
export const fblink = "https://miwatchfaces-b6312-default-rtdb.firebaseio.com";
export const appqrcodeurl = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=zpkd1";
export const wfqrcodeurl = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=zpkd1://getech2018.github.io/wfzpk/";


  


